import { flow } from "mobx";
import { applySnapshot, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { MessageModel } from "../../components/common/message";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { BAAC } from "./BAACService";

export const BAACModel = types
  .model("BAACModel", {
    id: customtypes.optional(types.string, ""),
    createdDate: customtypes.optional(types.string, ""),
    updatedDate: customtypes.optional(types.string, ""),
    createdBy: types.maybeNull(types.number),
    createdByName: customtypes.optional(types.string, ""),
    updatedBy: types.maybeNull(types.number),
    updatedByName: customtypes.optional(types.string, ""),
    method: customtypes.optional(types.string, ""),
    type: customtypes.optional(types.string, ""),
    reqDate: customtypes.optional(types.string, ""),
    postDate: customtypes.optional(types.string, ""),
    respCode: customtypes.optional(types.string, ""),
    respDesc: customtypes.optional(types.string, ""),
    reqReferenceNo: customtypes.optional(types.string, ""),
    resReferenceNo: customtypes.optional(types.string, ""),
    channelCode: customtypes.optional(types.string, ""),
    bankCode: customtypes.optional(types.string, ""),
    branchCode: customtypes.optional(types.string, ""),
    userCode: customtypes.optional(types.string, ""),
    terminalNo: customtypes.optional(types.string, ""),
    terminalLocation: customtypes.optional(types.string, ""),
    terminalType: customtypes.optional(types.string, ""),
    verifyRefNo: customtypes.optional(types.string, ""),
    taxId: customtypes.optional(types.string, ""),
    compCode: customtypes.optional(types.string, ""),
    serviceCode: customtypes.optional(types.string, ""),
    customerName: customtypes.optional(types.string, ""),
    accountNo: customtypes.optional(types.string, ""),
    accountTypeCode: customtypes.optional(types.string, ""),
    accountBranchCode: customtypes.optional(types.string, ""),
    chequeRefNo: customtypes.optional(types.string, ""),
    chequeUuid: customtypes.optional(types.string, ""),
    chequeNo: customtypes.optional(types.string, ""),
    chequeBankCode: customtypes.optional(types.string, ""),
    chequeBranchCode: customtypes.optional(types.string, ""),
    chequeAccountNo: customtypes.optional(types.string, ""),
    chequeAmount: customtypes.optional(types.string, ""),
    chequeDate: customtypes.optional(types.string, ""),
    transAmount: customtypes.optional(types.string, ""),
    feeAmount1: customtypes.optional(types.string, ""),
    feeAmount2: customtypes.optional(types.string, ""),
    feeAmount3: customtypes.optional(types.string, ""),
    feeAmount4: customtypes.optional(types.string, ""),
    feeAmount5: customtypes.optional(types.string, ""),
    feeAmount6: customtypes.optional(types.string, ""),
    ref1: customtypes.optional(types.string, ""),
    ref2: customtypes.optional(types.string, ""),
    ref3: customtypes.optional(types.string, ""),
    ref4: customtypes.optional(types.string, ""),
    ref5: customtypes.optional(types.string, ""),
    ref6: customtypes.optional(types.string, ""),
    ref7: customtypes.optional(types.string, ""),
    ref8: customtypes.optional(types.string, ""),
    ref9: customtypes.optional(types.string, ""),
    ref10: customtypes.optional(types.string, ""),
    ref11: customtypes.optional(types.string, ""),
    ref12: customtypes.optional(types.string, ""),
    ref13: customtypes.optional(types.string, ""),
    ref14: customtypes.optional(types.string, ""),
    ref15: customtypes.optional(types.string, ""),
    ref16: customtypes.optional(types.string, ""),
    ref17: customtypes.optional(types.string, ""),
    ref18: customtypes.optional(types.string, ""),
    ref19: customtypes.optional(types.string, ""),
    ref20: customtypes.optional(types.string, ""),
    error: types.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
    alert: types.optional(MessageModel, {})
  })
  .views((self: any) => ({
    get BAACJSON() {
      return self.toJSON();
    }
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key, index) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on key", key, e);
          throw e;
        }
      });
    },
    getBAACDetail: flow(function*() {
      if (self.id) {
        try {
          self.setField({ fieldname: "loading", value: true });
          const result: any = yield BAAC.getById(self.id);
          self.setAllField(result.data);
          self.error.setField({ fieldname: "tigger", value: false });
        } catch (e) {
          self.error.setField({ fieldname: "tigger", value: true });
          self.error.setField({ fieldname: "code", value: e.code });
          self.error.setField({ fieldname: "title", value: e.name });
          self.error.setField({
            fieldname: "message",
            value: e.message
          });
          self.error.setField({
            fieldname: "technical_stack",
            value: e.technical_stack
          });
          console.log(e);
        } finally {
          self.setField({ fieldname: "loading", value: false });
        }
      }
    }),
    resetAll: () => {
      applySnapshot(self, {});
    }
  }));
export type IBAACModel = typeof BAACModel.Type;
